import React, { Component } from "react";
// import { Carousel } from "react-responsive-carousel";
import classes from "./CarouselImages.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "animate.css/animate.min.css";
import Slider from "react-slick";
import mono_1 from "../images/Learningtoletgo/1.jpg";
import mono_2 from "../images/Learningtoletgo/2.jpg";
import mono_3 from "../images/Learningtoletgo/3.jpg";
import mono_4 from "../images/Learningtoletgo/4.jpg";
import mono_5 from "../images/Learningtoletgo/5.jpg";
import mono_6 from "../images/Learningtoletgo/6.jpg";
import mono_7 from "../images/Learningtoletgo/7.jpg";
import mono_8 from "../images/Learningtoletgo/8.jpg";
import mono_9 from "../images/Learningtoletgo/9.jpg";
import mono_10 from "../images/Learningtoletgo/10.jpg";
import mono_11 from "../images/Learningtoletgo/11.jpg";
import mono_12 from "../images/Learningtoletgo/12.jpg";
import mono_13 from "../images/Learningtoletgo/13.jpg";
import mono_14 from "../images/Learningtoletgo/14.jpg";
import ArrowBackIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";
class CarouselImagesLearning extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.number = 2;
  }
  componentDidMount() {
    // let track = this.slider.current.innerSlider.list.querySelector(
    //   ".slick-track"
    // );
    let focusSlider = setTimeout(() => {
      let slide = document.querySelector(".slick-track .slick-slide");
      slide.focus();
    }, 0);
    return () => clearTimeout(focusSlider);
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      fade: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2
    };
    return (
      <div className={classes.carousel} id="start">
        {/* <ScrollAnimation offset="0" animateIn="fadeInLeft" duration='2.4' animateOnce="true" initiallyVisible ={true}> */}
        <Slider ref={c => (this.slider = c)} {...settings}>
          <div className={classes.image_container}>
            <img className={classes.image} src={mono_1} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_2} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_3} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_4} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_5} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_6} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_7} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>
          <div className={classes.image_container}>
            <img className={classes.image} src={mono_8} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_9} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_10} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_11} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_12} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_13} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>

          <div className={classes.image_container}>
            <img className={classes.image} src={mono_14} alt="myImage" />
            <div className={classes.h1}>{/* <h1>I'm Abhijit</h1> */}</div>
          </div>
          <div className={classes.image_container}>
            <h6>Learning to let go (2021-22)</h6>
            <br></br>
            <p className={classes.para}>
              In a post-pandemic world, I decided to face my fear of water. I started to
              document the process with an improvised underwater toy camera and eventually
              gave in to my fear. Almost a year later, I mustered the courage to go back to the
              pool and finally learn how to swim. I developed the black and white negatives,
              scanned and printed them on bond paper and intervened to see them in colour. All
              of it to revisit this small personal victory.
            </p>
          </div>
        </Slider>
        <div style={{ textAlign: "left" }} className={classes.arrows}>
          <span className="button" onClick={this.previous}>
            <ArrowBackIcon
              style={{
                fontSize: "small",
                fontStyle: "italic",
                color: "#c4c0c0"
              }}
            />
          </span>

          <span className="button" onClick={this.next}>
            <ArrowForwardIcon
              style={{
                fontSize: "small",
                fontStyle: "italic",
                color: "#c4c0c0"
              }}
            />
          </span>
        </div>
        {/* </ScrollAnimation> */}
      </div>
    );
  }
}
export default CarouselImagesLearning;
